export const maxLength = (max) => (value) => {
  if (typeof value !== "string") return "Invalid input";
  return value.length <= max || `Maximum length allowed is ${max} characters`;
};

export const minLength = (min) => (value) => {
  if (typeof value !== "string") return "Invalid input";
  return value.length >= min || `Minimum length required is ${min} characters`;
};

// export const isNumberOnly = (value) => {
//     if (typeof value !== "string" && typeof value !== "number") return "Invalid input";
//     return /^[0-9]+$/.test(value.toString()) || "Only numeric values are allowed";
// };

export const isTextOnly = (value) => {
  if (typeof value !== "string" || value.trim() === "") return "Invalid input";
  return /^[A-Za-z\s]+$/.test(value)
    ? true
    : "Only alphabetic characters are allowed";
};

export const maxValue = (max) => (value) => {
  if (isNaN(value)) return "Invalid input";
  return (
    parseFloat(value) <= max || `Value must be less than or equal to ${max}`
  );
};

export const minValue = (min) => (value) => {
  if (isNaN(value)) return "Invalid input";
  return (
    parseFloat(value) >= min || `Value must be greater than or equal to ${min}`
  );
};
export const isSymbolOnly = (value) => {
  if (typeof value !== "string") return "Invalid input";
  return /^[^A-Za-z0-9\s]+$/.test(value) || "Symbols only allowed";
};

// export const isRequired = (value) => {
//     if (value === null || value === undefined || value === '') {
//         return "This field is required";
//     }
//     return true;
// };

export const isEmail = (value) => {
  if (typeof value !== "string") return "Invalid email address";
  if (value.trim() === "") return true;

  // ❌ Reject uppercase letters explicitly
  if (/[A-Z]/.test(value)) {
    return "Email must be in lowercase";
  }

  // ✅ lowercase-only email regex
  const emailRegex = /^[a-z0-9._-]+@[a-z0-9.-]+\.[a-z]{2,}$/;

  if (!emailRegex.test(value)) {
    return "Invalid email address";
  }

  // Extra validations
  if (value.includes("..")) return "Invalid email address";

  const [localPart, domain] = value.split("@");
  if (
    localPart.startsWith(".") ||
    localPart.endsWith(".") ||
    domain.startsWith(".") ||
    domain.endsWith(".")
  ) {
    return "Invalid email address";
  }

  return true;
};


export const isNotText = (value) => {
  if (typeof value !== "string" || value.trim() === "") return true;
  return !/^[A-Za-z\s]+$/.test(value) || "Text is not allowed";
};

export const isNotNumber = (value) => {
  if (isNaN(value)) return true;
  return "Numbers are not allowed";
};
export const maxDigit = (max) => (value) => {
  if (typeof value !== "string" && typeof value !== "number")
    return "Invalid input";
  const numericValue = value.toString().replace(/[^0-9]/g, "");
  return numericValue.length <= max || `Value must have at most ${max} digits`;
};

export const minDigit = (min) => (value) => {
  if (typeof value !== "string" && typeof value !== "number")
    return "Invalid input";
  const numericValue = value.toString().replace(/[^0-9]/g, "");
  return numericValue.length >= min || `Value must have at least ${min} digits`;
};
export const isNumberAndTextOnly = (value) => {
  if (typeof value !== "string" || value.trim() === "") return "Invalid input";
  return (
    /^[A-Za-z0-9\s]+$/.test(value) || "Only alphanumeric characters are allowed"
  );
};

export const isValidWebsiteURL = (value) => {
  if (!value || value.trim() === "") return true; // field optional

  const pattern = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

  return (
    pattern.test(value.trim()) ||
    "Enter a valid URL (must start with http:// or https://)"
  );
};

export const isRequired = (value) => {
  if (Array.isArray(value)) {
    // Check if the array is empty or contains any empty/invalid values
    if (
      value.length === 0 ||
      value.some(
        (item) =>
          item === null ||
          item === undefined ||
          (typeof item === "string" && item.trim() === "")
      )
    ) {
      return "This field is required";
    }
  } else if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return "This field is required";
  }
  return true;
};

export const isNumberOnly = (value) => {
  if (value === null || value === undefined || value === "") return true; // Allow empty for now; isRequired will handle it.
  if (typeof value !== "string" && typeof value !== "number")
    return "Invalid input";
  return /^[0-9]+$/.test(value.toString()) || "Only numeric values are allowed";
};

export const isValidCountryCode = (value) => {
  if (typeof value !== "string" || value.trim() === "")
    return "Country code is required";
  return (
    /^\+\d+$/.test(value) ||
    "Country code must start with '+' followed by numbers only"
  );
};

export const isPrice = (value) => {
  if (typeof value !== "string" || value.trim() === "") return "Invalid input";
  return /^[0-9]*\.?[0-9]+$/.test(value)
    ? true
    : "Please enter a valid  amount";
};

export const isDecimalNumber = (value) => {
  if (typeof value !== "string" || value.trim() === "") return "Invalid input";
  return /^[0-9]*\.?[0-9]+$/.test(value) ? true : "Please enter a valid input";
};

export const isValidLicensePlate = (value) => {
  if (value === null || value === undefined || value === "") return true; // let isRequired handle empty
  const str = value.toString().trim();
  if (str.length > 14) return "License plate must not exceed 14 characters";
  if (!/^[A-Za-z0-9 \-]+$/.test(str))
    return "License plate can only contain letters, numbers, spaces, and hyphens";
  return true;
};

export const isValidPolicyNumber = (value) => {
  if (value === null || value === undefined || value === "") return true; // let isRequired handle empty
  const str = value.toString().trim();
  if (str.length > 30) return "Policy number must not exceed 30 characters";
  if (!/^[A-Za-z0-9]+$/.test(str))
    return "Policy number can only contain letters and numbers";
  return true;
};

export const maxWholeDigits = (max) => (value) => {
  if (value === null || value === undefined || value === "") return true;
  const wholePart = value.toString().split(".")[0];
  return (
    wholePart.length <= max ||
    `Amount cannot exceed ${max} digits before the decimal point`
  );
};

export const disableFutureDates = (value) => {
  if (typeof value !== "string" || value.trim() === "") return "Invalid input";

  const enteredDate = new Date(value);
  const today = new Date();

  today.setHours(0, 0, 0, 0);

  return enteredDate > today ? "Future dates are not allowed" : true;
};

export const isValidChassisNumber = (value) => {
  if (value === null || value === undefined || value === "") return true; // Allow empty; required validation is separate.
  if (typeof value !== "string") return "Invalid input";

  const strValue = value.trim(); // Trim spaces

  if (!/^[A-HJ-NPR-Z0-9]+$/.test(strValue))
    return "Only alphanumeric characters (A-Z, 0-9) are allowed (I, O, Q are excluded)";
  if (strValue.length !== 17)
    return "Chassis number must be exactly 17 characters long";

  return true; // Valid chassis number
};

export const validateStartDate = (value, startDate) => {
  if (!value) return "Please select a date.";

  const dateParts = value.split("-");
  if (dateParts.length !== 3 || dateParts[0].length !== 4) {
    return "Invalid date format. Year must be 4 digits.";
  }

  const valueDate = new Date(value);
  if (isNaN(valueDate.getTime())) {
    return "Invalid date format. Please enter a valid date.";
  }

  const year = parseInt(dateParts[0], 10);
  if (year > 9999) {
    return "Invalid date. Year cannot exceed four digits.";
  }

  if (startDate) {
    const minDate = new Date(startDate);
    if (isNaN(minDate.getTime())) {
      return "Invalid start date.";
    }

    if (valueDate < minDate) {
      const reversedStartDate = startDate.split("-").reverse().join("-");
      return `Select a date after ${reversedStartDate}`;
    }
  }

  return true;
};

export const isPassword = (value) => {
  if (!value) return true;

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{8,}$/;

  if (!passwordRegex.test(value)) {
    return "Password must be at least 8 characters and include uppercase, lowercase, number and special character";
  }

  return true;
};
